export enum SpecialUnitsListType {
	MANUAL = "MANUAL",
	MANAGED = "MANAGED",
}
